import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=08c95392&scoped=true&lang=pug&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=08c95392&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c95392",
  null
  
)

component.options.__file = "Welcome.vue"
export default component.exports